import { track } from "../track";

export const trackUploadBackgroundFail = (params: { error: string }) =>
  track({ event: "upload_background_fail", ...params });
